import React from "react";
import { Paper, Typography } from "@mui/material";
import EditDialog from "./EditDialog";

type ProfileCardPropsType = {
  title: string;
  isSameUser?: boolean;
  children: any;
  from?: string;
  image?: string;
  name?: string;
  city?: string;
  currentCompany?: string;
  headline?: string;
  introduction?: string;
  hero?: string;
  underGrad?: string;
  postGrad?: string;
  hobbies?: string[];
  goals?: string[];
  admiredCompanies?: string[];
  experience?: string;
  tagsAndIndustry?: string[];
  topSkills?: string[];
  featuredLinks?: string[];
  pastExperience?: any[];
};

function ProfileCard({
  title,
  isSameUser,
  children,
  from,
  image,
  name,
  city,
  currentCompany,
  headline,
  introduction,
  hero,
  underGrad,
  postGrad,
  hobbies,
  goals,
  admiredCompanies,
  experience,
  tagsAndIndustry,
  topSkills,
  featuredLinks,
  pastExperience,
}: ProfileCardPropsType) {
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{ px: 2, py: 1, mb: 2, height: "auto", position: "relative" }}
    >
      <Typography fontWeight="500" variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      {isSameUser && from !== "pastExperience" && (
        <EditDialog
          image={image!}
          name={name!}
          city={city!}
          currentCompany={currentCompany!}
          headline={headline!}
          from={from!}
          introduction={introduction!}
          hero={hero!}
          underGrad={underGrad!}
          postGrad={postGrad!}
          hobbies={hobbies!}
          goals={goals!}
          admiredCompanies={admiredCompanies!}
          experience={experience!}
          tagsAndIndustry={tagsAndIndustry}
          topSkills={topSkills!}
          featuredLinks={featuredLinks!}
          pastExperience={pastExperience!}
        />
      )}
      {children}
    </Paper>
  );
}

export default ProfileCard;
